// import Vue from 'vue';
// import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
// Vue.use({vueDropzone:vue2Dropzone});
